export enum CombinationSpecificParamNamesEnum {
    Geveloppervlakte = 'Geveloppervlakte',
    MpgAmbitie = 'Mpg ambitie',
    Compactheid = 'Compactheid',
    Functies = 'Functies',
    GemeenschappelijkeRuimte = 'Gemeenschappelijke ruimte',
    MpgLimitEased = 'Mpg Limit Eased',
    MpgLimit = 'Mpg Limit',
    Correctiefactor = 'Correctiefactor'
}
